export function getContentColourUtilityClassName(colour: App.Design.ContentColour): string {
  return `content-colour-${colour}`
}
